module.exports = __webpack_public_path__ + "img/magazine25.56b11c37.jpg";